export const BASE_LOCATION_TERMINAL_STATUS_PING_TIME = 16;
